import { subscribe } from '../../common/errors/sagas';
import { subscribeConfiguration } from '../../common/saveconfiguration/sagas';
import { notificationError, notificationInfo } from '../../common/errors/notificationTypes';

const pre = 'CSASUMMARY/';

export const FETCH_CSASUMMARIES_REQUESTED = `${pre}FETCH_CSASUMMARIES_REQUESTED`;
export const FETCH_CSASUMMARIES_SUCCEEDED = `${pre}FETCH_CSASUMMARIES_SUCCEEDED`;
export const FETCH_CSASUMMARIES_FAILED = `${pre}FETCH_CSASUMMARIES_FAILED`;
export const SET_LOADING = `${pre}SET_LOADING`;
export const SET_CSASUMMARIES_COLUMNS = `${pre}SET_CSASUMMARIES_COLUMNS`;
export const SET_DEFAULT_FILTERS = `${pre}SET_DEFAULT_FILTERS`;
export const CSASUMMARIES_LOADED = `${pre}CSASUMMARIES_LOADING`;
export const SET_INITIALISED = `${pre}SET_INITIALISED`;
export const REFRESH_DATA = `${pre}REFRESH_DATA`;
export const APPLY_CLIENT_FILTERS = `${pre}APPLY_CLIENT_FILTERS`;
export const CSV_EXPORT_EMPTY = `${pre}CSV_EXPORT_EMPTY`;
export const FETCH_CSASUMMARIES_RETURNED_EMPTY = `${pre}FETCH_CSASUMMARIES_RETURNED_EMPTY`;
export const SET_GRID_SORTS = `${pre}SET_GRID_SORTS`;
export const SET_ALL_GRID_SORTS = `${pre}SET_ALL_GRID_SORTS`;
export const SET_DEFAULT_CONFIG = `${pre}SET_DEFAULT_CONFIG`;
export const FETCH_DEFAULT_CONFIG_FAILED = `${pre}FETCH_DEFAULT_CONFIG_FAILED`;
export const SWITCH_CURRENCIES = `${pre}SWTCH_CURRENCIES`;
export const REFRESH_CSASUMMARIES = `${pre}REFRESH_CSASUMMARIES`;

subscribe(FETCH_CSASUMMARIES_FAILED, 'Failed to fetch CSASummaries', notificationError);
subscribe(CSV_EXPORT_EMPTY, 'Failed to export as CSV - no data', notificationError);
subscribe(FETCH_CSASUMMARIES_RETURNED_EMPTY, 'Fetch CSV Summaries returned an empty list', notificationInfo);
subscribe(FETCH_DEFAULT_CONFIG_FAILED, 'Failed to fetch the default configuration', notificationInfo);
subscribeConfiguration(SET_CSASUMMARIES_COLUMNS, 'CSASummary');

export const refreshCsaSummary = () => ({
    type: REFRESH_CSASUMMARIES
});

export const setDefaultConfig = columns => ({
    type: SET_DEFAULT_CONFIG,
    columns
});

export const setAllGridSorts = data => ({
    type: SET_ALL_GRID_SORTS,
    data
});

export const setGridSorts = (gridId, sorting) => ({
    type: SET_GRID_SORTS,
    gridId,
    sorting
});

export const csvExportEmpty = error => ({
    type: CSV_EXPORT_EMPTY,
    error
});

export const applyClientFilters = clientFilters => ({
    type: APPLY_CLIENT_FILTERS,
    clientFilters
});

export const setInitialised = initialised => ({
    type: SET_INITIALISED,
    initialised
});

export const csaSummariesLoaded = () => ({
    type: CSASUMMARIES_LOADED
});

export const setDefaultFilters = filters => ({
    type: SET_DEFAULT_FILTERS,
    filters
});

export const setCsaSummariesColumns = data => ({
    type: SET_CSASUMMARIES_COLUMNS,
    data
});

export const fetchCsaSummariesRequested = () => ({
    type: FETCH_CSASUMMARIES_REQUESTED
});

export const fetchCsaSummariesSucceeded = (data, serverFilters) => ({
    type: FETCH_CSASUMMARIES_SUCCEEDED,
    data,
    serverFilters
});

export const fetchCsaSummariesEmpty = error => ({
    type: FETCH_CSASUMMARIES_RETURNED_EMPTY,
    error
});

export const fetchCsaSummariesFailed = error => ({
    type: FETCH_CSASUMMARIES_FAILED,
    error
});

export const fetchDefaultConfigFailed = error => ({
    type: FETCH_DEFAULT_CONFIG_FAILED,
    error
});

export const setLoading = loading => ({
    type: SET_LOADING,
    loading
});

export const refreshData = () => ({
    type: REFRESH_DATA
});

export const switchCurrencies = () => ({
    type: SWITCH_CURRENCIES
});
